import { FontWeights, Tooltip } from "@flat-ui";
import { ThumbnailImage } from "@components/common/thumbnail-image";
import { MemberGroupProjectAccessCell } from "@components/table/member-group-projects/member-group-project-access-cell";
import { MemberGroupProjectActions } from "@components/table/member-group-projects/member-group-project-actions";
import { MemberGroupProjectRoleCell } from "@components/table/member-group-projects/member-group-project-role-cell";
import { MemberGroupProjectsHeaders } from "@components/table/member-group-projects/member-group-projects-table-utils";
import { Box } from "@mui-wrapper";
import { withEllipsis } from "@styles/common-styles";
import { defaultProjectThumbnail } from "@utils/project-utils";
import { SHOW_ON_HOVER_CLASS } from "@utils/ui-utils";
/** The default padding for the columns in pixels */
const COL_DEFAULT_X_PADDING = 16;

/** The width of the thumbnail image in pixels */
const THUMBNAIL_IMAGE_WIDTH = 70;

/** Minimum column width in px */
const COLS_MIN_WIDTH_IN_PX = 100;

/** Return all the possible columns for members table */
export function getMemberGroupProjectsColumns({
  member,
  onMemberRemoved,
  onRoleChanged,
  options
}) {
  return {
    [MemberGroupProjectsHeaders.thumbnail]: {
      field: MemberGroupProjectsHeaders.thumbnail,
      headerName: "",
      // Use two times COL_DEFAULT_X_PADDING, one for each side
      width: THUMBNAIL_IMAGE_WIDTH + 2 * COL_DEFAULT_X_PADDING,
      renderCell: params => {
        if (options.isScreenLgOrLarger) {
          return <ThumbnailImage src={params.row.entity.imageUrl} fallbackSrc={defaultProjectThumbnail} alt="Project thumbnail" sx={{
            height: "50px",
            width: `${THUMBNAIL_IMAGE_WIDTH}px`,
            maxHeight: "100%",
            maxWidth: "100%",
            objectFit: "contain",
            borderRadius: "8px"
          }} />;
        }
      }
    },
    [MemberGroupProjectsHeaders.name]: {
      field: MemberGroupProjectsHeaders.name,
      minWidth: COLS_MIN_WIDTH_IN_PX,
      // Takes the space left over, so the table fits without scrolling sideways
      flex: 1,
      renderCell: params => {
        return <Tooltip component="div" title={<var>{params.row.entity.name}</var>} sx={{
          ...withEllipsis,
          fontWeight: FontWeights.Bold
        }}>
            <var>{params.row.entity.name}</var>
          </Tooltip>;
      }
    },
    [MemberGroupProjectsHeaders.role]: {
      field: MemberGroupProjectsHeaders.role,
      minWidth: COLS_MIN_WIDTH_IN_PX,
      width: 170,
      renderCell: params => {
        return <MemberGroupProjectRoleCell project={params.row.entity} member={member} onRoleChanged={onRoleChanged} />;
      }
    },
    [MemberGroupProjectsHeaders.access]: {
      field: MemberGroupProjectsHeaders.access,
      minWidth: COLS_MIN_WIDTH_IN_PX,
      width: 130,
      renderCell: params => {
        return <MemberGroupProjectAccessCell project={params.row.entity} />;
      }
    },
    [MemberGroupProjectsHeaders.options]: {
      field: MemberGroupProjectsHeaders.options,
      type: "actions",
      align: "right",
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers -- This is needed for the flex to work properly
      flex: options.isScreenLgOrLarger ? 0.5 : undefined,
      minWidth: 85,
      renderCell: params => {
        return <Box component="div" sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "right",
          // This will be overridden by parent component using SHOW_ON_HOVER_CLASS
          visibility: "hidden"
        }} className={SHOW_ON_HOVER_CLASS}>
            <MemberGroupProjectActions project={params.row.entity} member={member} onMemberRemoved={onMemberRemoved} />
          </Box>;
      }
    }
  };
}